module.exports = __webpack_public_path__ + "img/act_5_question3.bbae42a6.png";